'use client'

import { ButtonSocialMediaShare } from './ui/ButtonSocialMediaShare.component'
import { IconType } from './ui/Icon.types'

export const SocialMediaShare = ({ linkUrl }: { linkUrl: string }) => {
  return (
    <div className="">
      <ButtonSocialMediaShare
        iconType={IconType.x_twitter}
        href={`https://twitter.com/intent/tweet?text=${linkUrl}`}
      />
      <ButtonSocialMediaShare
        iconType={IconType.facebook}
        href={`https://www.facebook.com/sharer/sharer.php?u=${linkUrl}`}
      />
      <ButtonSocialMediaShare
        iconType={IconType.linkedin}
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${linkUrl}`}
      />
      <ButtonSocialMediaShare
        onClick={() => navigator.clipboard.writeText(linkUrl)}
        iconType={IconType.link}
      />
    </div>
  )
}
